import React from 'react';
import _ from 'lodash';
import {Container} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useQueryParam} from '../util/react_hooks.js';
import TarotSpreadComp from '../components/TarotSpreadComp.js';
import SCButton from '../components/SCButton.js';

const TarotSpread = ()=>{
    let [backLink] = useQueryParam('back_link');
    let [backText] = useQueryParam('back_text');
    return <Container maxWidth="lg">
      {backLink&&<SCButton text={backText||'חזרה'} variant="text"
        icon={<ChevronRightIcon/>} onClick={()=>window.open(backLink, '_self')}/>}
      <TarotSpreadComp/>
    </Container>;
};

export default TarotSpread;
